import { render, staticRenderFns } from "./value-calculator.vue?vue&type=template&id=40f28bb4"
import script from "./value-calculator.vue?vue&type=script&lang=js"
export * from "./value-calculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports